import React, { useState } from 'react'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import Installments from '../fragments/installments'
import { Box, Boxes } from '../../../layout/box'
import {
    __Pay_Ebanx__
} from '../../../../../../utils/paymethods'
import Ebanx from '../fragments/ebanx'
import { BigButton } from '../../../../../components/button'
import withEbanx from './hocs/ebanx'
import Paying from '../components/loading/paying'
import { FormattedMessage } from 'react-intl'

const CardBody = withEbanx(props => {
    useStyles(classes)
    const { cardList, creditOrder, children, showNew, payMethod, submiting, onError, handleSubmit, handleCredit } = props
    const selectedCard = cardList?.find?.(c => c.isSelected)
    const [selectedInstallment, setSelectedInstallment] = useState(creditOrder?.installments?.find(i => i.selected)?.number || 1)

    const onSubmit = payment => {
        handleSubmit(payment, selectedInstallment)
    }

    return <>
        <Boxes>
            {
                (selectedCard?.quickpayRecord?.payMethod === __Pay_Ebanx__ || showNew && payMethod === __Pay_Ebanx__) && <Box className={classes.InstallmentsContainer}>
                    <Installments value={selectedInstallment} onChange={setSelectedInstallment} installments={creditOrder?.installments} />
                </Box>

            }
            {
                showNew && <Box className={classes.EbanxBox}>
                    <Ebanx creditOrder={creditOrder} payMethod={payMethod} onError={onError} onSubmit={onSubmit} />
                </Box>
            }

        </Boxes>
        {
            children
        }
        {
            !showNew && <div className={classes.PayBtn}>
                <BigButton loading={submiting} type="submit" onClick={e => handleCredit(e, selectedInstallment)}><FormattedMessage id="pay_now" defaultMessage={'Pay Now'}/></BigButton>
            </div>
        }
        {
            submiting && <Paying/>
        }
    </>
})

export default CardBody